angular.module("app")
/**
 * pageTitle - Directive for set Page title - mata title
 */
.directive('pageTitle', ['$rootScope', '$timeout', '$filter', function pageTitle($rootScope, $timeout, $filter) {
    return {
        link: function (scope, element) {
           
            var listener = function (event, toState, toParams, fromState, fromParams) {
                // Default title - load on Dashboard 1 {{'app.title' | translate}}
                var title = $filter('translate')('app.title');
                // Create your own title pattern
                if (toState.data && toState.data.pageTitle) title = $filter('translate')('app.urlTitle') + ' | ' + toState.data.pageTitle;
                $timeout(function () {
                    element.text(title);
                });
            };
            $rootScope.$on('$stateChangeStart', listener);
        }
    }
}])

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
.directive('sideNavigation',['$timeout', '$rootScope', function sideNavigation($timeout, $rootScope) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {            
            scope.$watch(attr.watchMe, function (newValue, oldValue) {                
                if (newValue != oldValue) {                    
                    (element as any).metisMenu({ preventDefault: false });
                }
                
            })            
        }
    };
}])